import { NgModule } from '@angular/core';

import { NutritionPageModule } from 'pages/nutrition/nutrition.module';
import { NutritionInfoPageModule } from 'pages/nutrition-info-page/nutrition-info-page.module';
import { NutritionOptionsPageModule } from 'pages/nutrition-options-page/nutrition-options-page.module';
import { FoodsPageModule } from 'pages/foods/foods.module';
import { EditFoodPageModule } from 'pages/edit-food/edit-food.module';
import { EditIngredientPageModule } from 'pages/edit-ingredient/edit-ingredient.module';
import { EditMealPageModule } from 'pages/edit-meal/edit-meal.module';
import { EditNutritionPlanPageModule } from 'pages/edit-nutrition-plan/edit-nutrition-plan.module';
import { MealPlanPageModule } from 'pages/meal-plan/meal-plan.module';
import { MealSuggestionsPageModule } from 'pages/meal-suggestions/meal-suggestions.module';

const NUTRITION_PAGE_MODULES = [
  NutritionPageModule,
  NutritionInfoPageModule,
  NutritionOptionsPageModule,
  FoodsPageModule,
  EditFoodPageModule,
  EditIngredientPageModule,
  EditMealPageModule,
  EditNutritionPlanPageModule,
  MealPlanPageModule,
  MealSuggestionsPageModule,
];

/**
 * The food, meal and nutrition-plan screens.
 *
 * One of the app's per-area page groups: it only groups page modules together,
 * declaring nothing of its own and adding no providers. Why these files exist and
 * what keeps them honest: `design-docs/angular-components.md`, "Creating New
 * Components", step 4.
 */
@NgModule({
  imports: NUTRITION_PAGE_MODULES,
  exports: NUTRITION_PAGE_MODULES,
})
export class NutritionPagesModule { }
